import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA,MatDialog as MatDialog } from '@angular/material/dialog';
import { MediaService } from 'src/app/new-media/common/media.service';
import { SecurityComponent } from 'src/app/views/security/security.component';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-manage-media',
  templateUrl: './manage-media.component.html',
  styleUrls: ['./manage-media.component.css']
})
export class ManageMediaComponent implements OnInit {
  data: any;
  public activeTab: number = 1;
assignedRoles=[]
  constructor(
    private dialogRef: MatDialogRef<any>,
     public mediaManagerService: MediaService,
    private snotifyService: ToastrService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data) {
    this.data = data;
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  submit() {
  }
  updateSecurity() {
   
    this.mediaManagerService
      .getAssignedRolesMedia(this.data.id)
      .subscribe((res: any) => {

this.assignedRoles=[...res.assingedRoles]
        let dialogRef = this.dialog.open(SecurityComponent, {
          width: "70vw",
          data: {
            unAssigendRole: res.unassingedRoles,
            assigendRoles: res.assingedRoles,
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
       
            result.assigendRoles = result.assigendRoles.map((x) => x.id);
            let rolesAndAsigend: any = {
              addMediaRole: this.assignedRoles.length==0?{
                mediaIds: [this.data.id],
                roleIds: result.assigendRoles,
              }:null,
              "mediaId": this.assignedRoles.length?this.data.id:null,
              "roleIds": this.assignedRoles.length?result.assigendRoles:null
            };

            this.mediaManagerService
              .updateAssignedRolesMedia(rolesAndAsigend)
              .subscribe((res) => {
                this.snotifyService.success("Roles updated successfully");
              });
          }
        });
      });
  }
  public openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2500,
      progressBar: true,
      tapToDismiss: true
    });
  }
}
